'use strict';

angular.module('shiftTraderApp')
  .directive('saScheduleLineItem', ['NotesStore', 'Session', function (NotesStore, Session) {
    return {
      templateUrl: 'views/directives/saScheduleLineItem.html',
      restrict: 'A',
      scope: {
        scheduleItem:'=',
        me:'=loggedInUser',
        selectedUser:'=',
        index:'=',
        showWorkingWith: '@'
      },
      controller: ['$scope', '$uibModal', 'WorkPeriods', '$location', 'UserPermissionsService', '$q', function($scope, $uibModal, WorkPeriods, $location, UserPermissionsService, $q) {
        $scope._showWorkingWith = $scope.showWorkingWith !== 'false';

        $q.all(lodash.map(['trades.view_mine', 'trades.view_in_org'], function(permission) {
          return UserPermissionsService.can(permission, $scope.scheduleItem.organization_id)
        }))
          .then(function(results) {
            $scope.hasPermissionToViewTrade = (results[0] && $scope.scheduleItem.$isInvolvedInTrade($scope.me)) || results[1];
          });


        $scope._hasNotes = false;
        Session.isFeatureEnabled('notes')
          .then(function(res) {
            if (res) {
              NotesStore.getNotesWithFilter({obj: 'WorkPeriod', obj_id: $scope.scheduleItem.id})
              .then(function(notes) {
                if (notes.length > 0) {
                  $scope._numNotes = notes.length;
                  $scope._hasNotes = true;
                }
              }, function(response) {
                console.log('Failed to get notes', response);
              });
            }
          }, function(response) {

          });

        $scope.openTradeDialogSvr = function (mode) {
          var modalInstance = $uibModal.open({
            size: 'trade',
            keyboard: false,
            backdrop: 'static',
            templateUrl: 'views/tradeShiftSvr.html',
            controller: 'TradeDialogSvrCtrl',
            resolve: {
              workPeriod: function () {
                return $scope.scheduleItem;
              },
              me: function () {
                return $scope.me;
              },
              mode: function() {
                var a = {};
                a.mode = mode;
                return a;
              },
              org: ['Organizations', function (Organizations) {
                return Organizations.getCurrentOrg();
              }],
              allPositions: ['Positions', function(Positions) {
                return Positions.getAllInOrg();
              }]
            }
          });

          modalInstance.result.then(function (createdTrade) {
            if ( angular.isDefined(createdTrade) && createdTrade !== 'close' ) {
              $location.path('/trade/' + createdTrade.id);
            }
          }, function(reason) {
            console.log('createTradeDialog closed for reason ' + reason);
          });
        };
      }]
    };
  }]);
